module.exports = "https://trybtryb-legacy.web.app/img/overcoming-starter-mobile.cfd79517.webp";